export function withOutLastPart(pathName: string): string {
  const lastDash = pathName.lastIndexOf("/");
  return pathName.substring(0, lastDash);
}
